import React from 'react';
import { useParams } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';

import { useSigmaDashboardByTypeQuery } from 'generated/graphql';
import { SigmaEmbed } from 'components/SigmaEmbed/SigmaEmbed';

import { RouteParams } from './types';

const SigmaDashboard = () => {
  const { type } = useParams<RouteParams>();

  const { data: dashboardData, loading } = useSigmaDashboardByTypeQuery({
    fetchPolicy: 'network-only',
    variables: {
      type,
    },
  });

  const { sigmaUrl = '' } = dashboardData?.getSigmaDashboard || {};

  if (loading) {
    return <LinearProgress />;
  }

  return <SigmaEmbed sigmaUrl={sigmaUrl} />;
};

export default SigmaDashboard;
